import { markRaw } from 'vue'
import ModalAbstract from './ModalAbstract'
import ModalFileManage from './ModalFileManage.vue'

export default class ModalFileManageService extends ModalAbstract {
  public name = 'ModalFileManageService'
  protected component = markRaw(ModalFileManage)
}
